module.exports = __webpack_public_path__ + "img/verify2.5c095d09.jpg";